/**
 * First Sale Tracker Service
 *
 * REST API service for the First Sale Conversion Tracker.
 * Wraps all HTTP calls to the first_sale_tracker Firebase Cloud Function endpoint.
 */

import RestApi from './../../api/rest-api-client'

const srvcEndpoint = '/first_sale_tracker'

export default {
  /** Fetch the agent's active tracker (or create one). Returns tracker + steps + stats. */
  search: async (req, opts) => RestApi.request('GET', srvcEndpoint, req, opts),

  /** Fetch a specific tracker by ID. */
  get: async (id, req, opts) => RestApi.request('GET', srvcEndpoint, id, req, opts),

  /** Create a new tracker record. */
  store: async (data, opts) => RestApi.request('POST', srvcEndpoint, data, opts),

  /** Update a tracker record by ID. */
  update: async (id, data, opts) => RestApi.request('PUT', srvcEndpoint, id, data, opts),

  /** Toggle completion or update notes for a specific step. */
  updateStep: async (stepNumber, data, opts) => RestApi.request('PUT', `${srvcEndpoint}/steps`, stepNumber, data, opts),

  /** Archive current tracker and create a fresh one. */
  reset: async (data, opts) => RestApi.request('POST', `${srvcEndpoint}/reset`, data, opts),

  /** Fetch the performance stat (% first-sold within 7 days of onboarding). */
  stats: async (req, opts) => RestApi.request('GET', `${srvcEndpoint}/stats`, req, opts),

  /** Manually claim a side quest. */
  claimQuest: async (questKey, data, opts) =>
    RestApi.request('PUT', `${srvcEndpoint}/side-quests/${questKey}/claim`, data, opts),
}
